import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import showHideMenu from "./scripts/showHideMenu";
import reversePrints from "./scripts/reversePrints";
import { renderProjects } from './scripts/renderProjects';
import { initTheme } from './scripts/theme';
import { initCorgiMood } from './scripts/corgiMood'; // Импортируем логику корги
import { initI18n } from './scripts/i18n';

// Рендерим элементы в DOM ДО запуска ScrollReveal и VanillaTilt
renderProjects();

// Инициализируем переводы и сразу обновляем динамические карточки
initI18n();

// Навешиваем эффекты на уже готовый и переведенный DOM
// Плавный скролл
initScrollReveal(targetElements, defaultProps);
initTiltEffect();
initTheme(); // иниц. тем
initCorgiMood(); // Запускаем смену настроения корги

// Слушатели событий
// Вешаем события клик для кнопок меню
document.querySelectorAll("svg.nav__toggle, a.nav__link").forEach((button) => {
  button.addEventListener("click", showHideMenu);
});

// меняем направление корги
const animationDuration = 30000; // ms
setInterval(reversePrints, animationDuration);